// extracted by mini-css-extract-plugin
export default {"langItem":"AmD0U","selected":"vQC4O","image":"F8jXG","title":"pDzag"};